import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../api/authApi";
import Message from "../components/Message";

export default function Login({ onUserUpdate }) {
  const [params, setParams] = useSearchParams();
  const role = params.get("role") || "customer";
  const [form, setForm] = useState({ email: "", password: "" });
  const [notice, setNotice] = useState(null);
  const navigate = useNavigate();

  function updateField(event) {
    setForm((current) => ({ ...current, [event.target.name]: event.target.value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    try {
      const response = await authApi.login({ ...form, role });
      // Update user state instead of reloading
      if (onUserUpdate && response.user) {
        onUserUpdate(response.user);
      }
      navigate(role === "admin" ? "/admin-dashboard" : "/");
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    }
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h1>{role === "admin" ? "Admin Login" : "Customer Login"}</h1>

        <div className="role-tabs">
          <button className={`role-tab ${role === "customer" ? "active" : ""}`} onClick={() => setParams({ role: "customer" })}>
            Customer
          </button>
          <button className={`role-tab ${role === "admin" ? "active" : ""}`} onClick={() => setParams({ role: "admin" })}>
            Admin
          </button>
        </div>

        <Message notice={notice} />

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input type="email" id="email" name="email" required className="form-control" value={form.email} onChange={updateField} />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input type="password" id="password" name="password" required className="form-control" value={form.password} onChange={updateField} />
          </div>

          <button type="submit" className="btn btn-primary btn-block">Login</button>
        </form>

        {role === "customer" ? (
          <p className="auth-link">
            Don&apos;t have an account? <Link to="/signup">Sign up here</Link>
          </p>
        ) : (
          <p className="auth-note">Admin accounts are created by administrators only.</p>
        )}
      </div>
    </div>
  );
}
